import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierStoneManagerController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierStoneManagerController.php
* @route '/api/dossier/{dossier}/stone-manager'
*/
const FetchDossierStoneManagerController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierStoneManagerController.url(args, options),
    method: 'get',
})

FetchDossierStoneManagerController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/stone-manager',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierStoneManagerController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierStoneManagerController.php
* @route '/api/dossier/{dossier}/stone-manager'
*/
FetchDossierStoneManagerController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierStoneManagerController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierStoneManagerController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierStoneManagerController.php
* @route '/api/dossier/{dossier}/stone-manager'
*/
FetchDossierStoneManagerController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierStoneManagerController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierStoneManagerController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierStoneManagerController.php
* @route '/api/dossier/{dossier}/stone-manager'
*/
FetchDossierStoneManagerController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierStoneManagerController.url(args, options),
    method: 'head',
})

export default FetchDossierStoneManagerController